import IconTableRepository from "../IconTableRepository"

export default class FeatureIconTable extends IconTableRepository {
    static schemaId = "feature_iconTable"

    constructor() {
        super(FeatureIconTable.schemaId)
    }
}
